import {Component} from '@angular/core';
import {Router, RouterLink} from '@angular/router';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {
  isNavigating = false;

  constructor(private router: Router) {
  }

  async onLoginClick(event: MouseEvent): Promise<void> {
    event.preventDefault();

    if (this.isNavigating) {
      return;
    }

    this.isNavigating = true;

    try {
      await this.router.navigate(['/login']);
    } finally {
      this.isNavigating = false;
    }
  }
}
